/**
 * User API endpoint schemas
 *
 * Export all Zod schemas and types for user-related API endpoints
 */

// Profile schemas
export {
  UpdateProfileRequestSchema,
  UpdateProfileResponseSchema,
  type UpdateProfileRequest,
  type UpdateProfileResponse,
  type UpdateProfileSuccess,
} from './profile';

// Check email schemas
export {
  CheckEmailRequestSchema,
  CheckEmailResponseSchema,
  type CheckEmailRequest,
  type CheckEmailResponse,
  type CheckEmailSuccess,
} from './check-email';

// Username schemas
export {
  CheckUsernameRequestSchema,
  CheckUsernameResponseSchema,
  ChangeUsernameRequestSchema,
  ChangeUsernameResponseSchema,
  UsernameStatusResponseSchema,
  UsernameUnavailableReasonSchema,
  type CheckUsernameRequest,
  type CheckUsernameResponse,
  type CheckUsernameSuccess,
  type ChangeUsernameRequest,
  type ChangeUsernameResponse,
  type ChangeUsernameSuccess,
  type UsernameStatusResponse,
  type UsernameUnavailableReason,
} from './username';

// Deactivate schemas
export {
  DeactivateUserSuccessSchema,
  DeactivateUserResponseSchema,
  DeactivateUserRequestSchema,
  CloseCodeSuccessSchema,
  CloseCodeResponseSchema,
  type DeactivateUserSuccess,
  type DeactivateUserResponse,
  type DeactivateUserRequest,
  type CloseCodeResponse,
} from './deactivate';

// Upload photo schemas (presigned URL)
export {
  UploadPhotoRequestSchema,
  UploadPhotoResponseSchema,
  type UploadPhotoRequest,
  type UploadPhotoResponse,
  type UploadPhotoSuccess,
} from './upload-photo';

// Upload photo base64 schemas
export {
  UploadPhotoBase64RequestSchema,
  UploadPhotoBase64ResponseSchema,
  type UploadPhotoBase64Request,
  type UploadPhotoBase64Response,
  type UploadPhotoBase64Success,
} from './upload-photo-base64';

// Wishlist schemas
export {
  WishlistRequestSchema,
  AddToWishlistRequestSchema,
  WishlistItemSchema,
  WishlistResponseSchema,
  WishlistActionResponseSchema,
  WishlistGetResponseSchema,
  type WishlistRequest,
  type AddToWishlistRequest,
  type WishlistItem,
  type WishlistResponse,
  type WishlistActionResponse,
  type WishlistGetResponse,
  type WishlistSuccess,
} from './wishlist';

// Verify email schemas
export {
  VerifyEmailRequestSchema,
  VerifyEmailProfileSchema,
  VerifyEmailSuccessSchema,
  VerifyEmailErrorSchema,
  VerifyEmailResponseSchema,
  type VerifyEmailRequest,
  type VerifyEmailProfile,
  type VerifyEmailSuccess,
  type VerifyEmailError,
  type VerifyEmailResponse,
} from './verify-email';

// NextAuth session schemas (for UserProvider)
export {
  SessionUserProfileSchema,
  NextAuthSessionResponseSchema,
  type SessionUserProfile,
  type NextAuthSessionResponse,
} from './session';
